import SummonerInfo from "./SummonerInfo";
import SummonerRank from "./SummonerRank";
import styles from "./Header.module.css";

const Header = ({ sum, width }) => {
  if (!sum) return <></>;
  const info = {
    region: sum.region,
    name: sum.name,
    update: sum ? parseInt(sum["modified-ranks"]) : 0,
    request: sum ? Math.min(sum["request-ranks"], sum["request-matches"]) : 0,
    rank: sum["solo-rank"],
    level: sum.level,
    icon: sum.icon,
    s2020: sum["solo-20-tier"]
      ? sum["solo-20-tier"] +
        (sum["solo-20-tier"] !== "MASTER" &&
        sum["solo-20-tier"] !== "GRANDMASTER" &&
        sum["solo-20-tier"] !== "CHALLENGER"
          ? " " + sum["solo-20-division"]
          : "")
      : "",
    s2021: sum["solo-21-tier"]
      ? sum["solo-21-tier"] +
        (sum["solo-21-tier"] !== "MASTER" &&
        sum["solo-21-tier"] !== "GRANDMASTER" &&
        sum["solo-21-tier"] !== "CHALLENGER"
          ? " " + sum["solo-21-division"]
          : "")
      : "",
    s2022: sum["solo-22-tier"]
      ? sum["solo-22-tier"] +
        (sum["solo-22-tier"] !== "MASTER" &&
        sum["solo-22-tier"] !== "GRANDMASTER" &&
        sum["solo-22-tier"] !== "CHALLENGER"
          ? " " + sum["solo-22-division"]
          : "")
      : "",
    s2023a: sum["solo-23a-tier"]
      ? sum["solo-23a-tier"] +
        (sum["solo-23a-tier"] !== "MASTER" &&
        sum["solo-23a-tier"] !== "GRANDMASTER" &&
        sum["solo-23a-tier"] !== "CHALLENGER"
          ? " " + sum["solo-23a-division"]
          : "")
      : "",
  };
  return (
    <div className={styles[width]}>
      <SummonerInfo info={info} width={width} />
      <div className={styles["ranks_" + width]}>
        <SummonerRank
          type="Solo/Duo"
          tier={sum["solo-tier"]}
          division={sum["solo-division"]}
          lp={sum["solo-lp"]}
          wins={sum["solo-wins"]}
          losses={sum["solo-losses"]}
          width={width}
        />
        <div className={styles.rankdivider}>
          <div></div>
        </div>
        <SummonerRank
          type="Flex 5v5"
          tier={sum["flex-tier"]}
          division={sum["flex-division"]}
          lp={sum["flex-lp"]}
          wins={sum["flex-wins"]}
          losses={sum["flex-losses"]}
          width={width}
        />
      </div>
    </div>
  );
};

export default Header;
